import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asVideoConsultationInfo" }
const _hoisted_2 = { class: "asVideoConsultationInfo_header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultationInfo_close" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "asVideoConsultationInfo_content" }
const _hoisted_6 = { class: "asVideoConsultationInfo_title" }
const _hoisted_7 = { class: "asVideoConsultationInfo_subTitle" }
const _hoisted_8 = { class: "asVideoConsultationInfo_form_dateTime_wrapper" }
const _hoisted_9 = { class: "asInput_label" }
const _hoisted_10 = { class: "asVideoConsultationInfo_form_dateTime" }
const _hoisted_11 = {
  type: "submit",
  class: "asVideoConsultationInfo_form_submit"
}
const _hoisted_12 = {
  key: 0,
  class: "asVideoConsultationInfo_title"
}
const _hoisted_13 = { class: "-date" }
const _hoisted_14 = { class: "-time" }
const _hoisted_15 = {
  key: 0,
  class: "asVideoConsultationInfo_tip"
}
const _hoisted_16 = {
  key: 1,
  class: "asVideoConsultationInfo_title -done"
}
const _hoisted_17 = {
  key: 0,
  class: "asVideoConsultationInfo_subTitle"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/avatar.png",
  alt: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultationInfo_avatar_icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultationInfo_avatar_icon_wrapper" })
], -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  class: "asVideoConsultationInfo_actions"
}
const _hoisted_22 = ["href", "target"]
const _hoisted_23 = { class: "asVideoConsultationInfo_cancelModal" }
const _hoisted_24 = { class: "asVideoConsultationInfo_cancelModal_title" }
const _hoisted_25 = { class: "asVideoConsultationInfo_cancelModal_content" }
const _hoisted_26 = { class: "asVideoConsultationInfo_cancelModal_content_text -center" }
const _hoisted_27 = { class: "asVideoConsultationInfo_cancelModal_content_text -center" }
const _hoisted_28 = { class: "asVideoConsultationInfo_actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_input = _resolveComponent("as-input")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_as_date_time_picker = _resolveComponent("as-date-time-picker")!
  const _component_as_textarea = _resolveComponent("as-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_as_modal = _resolveComponent("as-modal")!
  const _component_as_preloader = _resolveComponent("as-preloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadedInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "asVideoConsultationInfo_close_wrapper",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isCreatedOrCanceled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t('videoConsultations.orderOnConsultation')) + " ", 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.videoConsultation.course.title), 1)
                  ]),
                  _createVNode(_component_v_form, {
                    onSubmit: _ctx.consultationPlanning,
                    class: "asVideoConsultationInfo_form"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_field, {
                        "model-value": _ctx.formPlanningData.phone,
                        name: "phone",
                        label: _ctx.$t('phone'),
                        rules: "required"
                      }, {
                        default: _withCtx(({ errors }) => [
                          _createVNode(_component_as_input, {
                            name: "phone",
                            label: _ctx.$t('videoConsultations.phoneLabel'),
                            type: "phone",
                            "model-value": _ctx.formPlanningData.phone,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formPlanning.phone = $event)),
                            placeholder: _ctx.$t('input.phone'),
                            error: _ctx.getFirstError('phone', errors),
                            class: "-grey -fullWidth"
                          }, null, 8, ["label", "model-value", "placeholder", "error"])
                        ]),
                        _: 1
                      }, 8, ["model-value", "label"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('videoConsultations.chooseDate')), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_v_field, {
                            "model-value": _ctx.formPlanningData.date,
                            name: "date",
                            label: _ctx.$t('videoConsultations.date'),
                            rules: "required"
                          }, {
                            default: _withCtx(({ errors }) => [
                              _createVNode(_component_as_date_time_picker, {
                                name: "date",
                                type: "date",
                                "model-value": _ctx.formPlanningData.date,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formPlanning.date = $event)),
                                error: _ctx.getFirstError('date', errors),
                                class: "asInput -grey",
                                "min-date": _ctx.minDate
                              }, null, 8, ["model-value", "error", "min-date"])
                            ]),
                            _: 1
                          }, 8, ["model-value", "label"]),
                          _createVNode(_component_v_field, {
                            "model-value": _ctx.formPlanningData.time,
                            name: "time",
                            label: _ctx.$t('videoConsultations.time'),
                            rules: "required"
                          }, {
                            default: _withCtx(({ errors }) => [
                              _createVNode(_component_as_date_time_picker, {
                                name: "time",
                                type: "time",
                                "model-value": _ctx.formPlanningData.time,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formPlanning.time = $event)),
                                error: _ctx.getFirstError('time', errors),
                                class: "asInput -grey",
                                "minute-interval": 10
                              }, null, 8, ["model-value", "error"])
                            ]),
                            _: 1
                          }, 8, ["model-value", "label"])
                        ])
                      ]),
                      _createVNode(_component_as_textarea, {
                        name: "note",
                        "model-value": _ctx.formPlanningData.note,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formPlanning.note = $event)),
                        class: "-grey -fullWidth",
                        label: _ctx.$t('videoConsultations.noteForExpert'),
                        placeholder: _ctx.$t('videoConsultations.commentPlaceholder'),
                        maxlength: "500"
                      }, null, 8, ["model-value", "label", "placeholder"]),
                      _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.$t('videoConsultations.order')), 1)
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.isPlanned || _ctx.isApproved || _ctx.isDone)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.isPlanned || _ctx.isApproved)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getDate(_ctx.videoConsultation.startDateTime)), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getTime(_ctx.videoConsultation.startDateTime)), 1),
                        (_ctx.isPlanned)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('videoConsultations.orderWaitApprove')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isDone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.$t('videoConsultations.consultationOver')) + " ", 1),
                        (_ctx.isDone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.getDate(_ctx.videoConsultation.startDateTime)) + " " + _toDisplayString(_ctx.getTime(_ctx.videoConsultation.startDateTime)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["asVideoConsultationInfo_avatar", {
            '-done': _ctx.isDone,
            '-approved': _ctx.isApproved,
            '-planned': _ctx.isPlanned,
          }])
                  }, _hoisted_20, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["asVideoConsultationInfo_text", {
            '-done': _ctx.isDone
          }])
                  }, _toDisplayString(_ctx.$t('videoConsultations.videoConsultationWithExpert')) + " " + _toDisplayString(_ctx.videoConsultation.course.title), 3),
                  (_ctx.isPlanned || _ctx.isApproved)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_ctx.isApproved)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "asVideoConsultationInfo_button -blue",
                              href: _ctx.videoConsultationHref,
                              target: _ctx.videoConsultationTarget,
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToMeeting && _ctx.goToMeeting(...args)))
                            }, _toDisplayString(_ctx.$t('videoConsultations.gotToConsultation')), 9, _hoisted_22))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "asVideoConsultationInfo_button -cancel",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowCancelModal = true))
                        }, _toDisplayString(_ctx.$t('videoConsultations.cancelOrder')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_as_modal, {
            modelValue: _ctx.isShowCancelModal,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isShowCancelModal) = $event)),
            btnClose: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('videoConsultations.cancelOrder')) + "? ", 1),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.$t('videoConsultations.VideoConsultation')) + " ", 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.getDate(_ctx.videoConsultation.startDateTime)) + ", " + _toDisplayString(_ctx.getTime(_ctx.videoConsultation.startDateTime)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", {
                      class: "asVideoConsultationInfo_cancelModal_content_link",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelConsultationByTechSupport && _ctx.cancelConsultationByTechSupport(...args)))
                    }, _toDisplayString(_ctx.$t('videoConsultations.cancelConsultationTechSupport')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "asVideoConsultationInfo_button -cancel",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowCancelModal = false))
                    }, _toDisplayString(_ctx.$t('videoConsultations.notCancelOrder')), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 64))
      : (_openBlock(), _createBlock(_component_as_preloader, { key: 1 }))
  ]))
}